"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProfileActionSearch;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _KeyboardShortcut = require("crm_ui/profile/shortcuts/KeyboardShortcut");

var _ProfileKeyboardShortcutHandler = require("crm_ui/profile/shortcuts/ProfileKeyboardShortcutHandler");

var _loggers = require("customer-data-tracking/loggers");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _I18n = _interopRequireDefault(require("I18n"));

var _userEnvHelpers = require("crm_ui/utils/userEnvHelpers");

var _KeyCodes = _interopRequireWildcard(require("crm_ui/profile/shortcuts/KeyCodes"));

var _KeyTesters = require("crm_ui/profile/shortcuts/KeyTesters");

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _CommunicatorActions = require("customer-data-communicator/data/communicator/actions/CommunicatorActions");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UITypeahead = _interopRequireDefault(require("UIComponents/typeahead/UITypeahead"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-height: 316px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MODAL_WIDTH = 408;

var TypeaheadWrapper = _styledComponents.default.div.withConfig({
  displayName: "ProfileActionSearch__TypeaheadWrapper",
  componentId: "j3hcqd-0"
})(_templateObject());

var specialCaseOptions = ['sequence'];
var typeaheadOptions = [_InteractionTypes.NOTE, _InteractionTypes.EMAIL, _InteractionTypes.CALL, _InteractionTypes.TASK, _InteractionTypes.SCHEDULE].concat(specialCaseOptions, [_InteractionTypes.LOGGED_EMAIL, _InteractionTypes.LOGGED_CALL, _InteractionTypes.LOGGED_MEETING]);

function ProfileActionSearch(_ref) {
  var handleOpenSequencesModal = _ref.handleOpenSequencesModal,
      showSequences = _ref.showSequences;

  var _useContext = (0, _react.useContext)(_SubjectContext.SubjectContext),
      subjectId = _useContext.subjectId,
      objectType = _useContext.objectType;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var typeaheadRef = (0, _react.createRef)();

  function getTypeaheadOptionLabelKey(option) {
    switch (option) {
      case 'email':
        return 'profileTimeline.actionLabels.email';

      case 'logged-email':
        return 'profileTimeline.actionLabels.logged-email';

      case 'note':
        return 'profileTimeline.actionLabels.note';

      case 'call':
        return 'profileTimeline.actionLabels.call';

      case 'logged-call':
        return 'profileTimeline.actionLabels.logged-call';

      case 'schedule':
        return 'profileTimeline.actionLabels.schedule';

      case 'logged-meeting':
        return 'profileTimeline.actionLabels.logged-meeting';

      case 'task':
        return 'profileTimeline.actionLabels.task';

      case 'sequence':
        return 'profileTimeline.actionLabels.sequence';

      default:
        return null;
    }
  }

  function getTypeaheadActions() {
    return typeaheadOptions.filter(function (option) {
      return option !== 'sequence' || showSequences;
    }).map(function (option) {
      return {
        text: _I18n.default.text(getTypeaheadOptionLabelKey(option)),
        value: option
      };
    });
  }

  function getShortcutActionKey() {
    if ((0, _userEnvHelpers.isEdge)() || (0, _userEnvHelpers.isFirefox)()) {
      return _KeyCodes.default.SLASH_KEY;
    }

    return _KeyCodes.default.K_KEY;
  }

  function handleSpecialCaseAction(action) {
    switch (action) {
      case 'sequence':
      default:
        handleOpenSequencesModal();
    }
  }

  function handleToggleModal(shouldBeOpen) {
    setIsOpen(function (currentIsOpen) {
      if (currentIsOpen !== shouldBeOpen) {
        return shouldBeOpen;
      }

      return currentIsOpen;
    });
  }

  function handleSelectAction(event) {
    var action = event.target.value;

    _loggers.CrmLogger.log('selectedActionsRedesignOption', {
      action: 'opened communicator from activity redesign',
      subAction: action,
      source: 'keyboard shortcut menu'
    });

    handleToggleModal(false);

    if (specialCaseOptions.includes(action)) {
      return handleSpecialCaseAction(action);
    }

    (0, _CommunicatorActions.showCommunicator)(action);
    return (0, _CommunicatorActions.setCommunicatorTriggerLocation)({
      triggerLocation: 'profile action search',
      subjectIdContext: subjectId,
      objectTypeContext: objectType
    });
  }

  function renderAcitonTypeahead() {
    var searchPlaceholder = _I18n.default.text('profileTimeline.actionsSearchModal.searchPlaceholder');

    return _react.default.createElement(TypeaheadWrapper, {
      className: "p-all-5"
    }, _react.default.createElement(_UITypeahead.default, {
      options: getTypeaheadActions(),
      onChange: handleSelectAction,
      placeholder: searchPlaceholder,
      ref: typeaheadRef,
      searchClassName: "p-all-0 m-bottom-4"
    }));
  }

  function renderControlsReminder() {
    return _react.default.createElement("span", {
      className: "p-x-8 p-bottom-3"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileTimeline.actionsSearchModal.controlsReminder.arrowKeys"
    }), _react.default.createElement(_FormattedHTMLMessage.default, {
      className: "p-left-3",
      message: "profileTimeline.actionsSearchModal.controlsReminder.enterKey"
    }));
  }

  (0, _react.useEffect)(function () {
    if (typeaheadRef && typeaheadRef.current) {
      typeaheadRef.current.focus();
    }
  });
  var openModalShortcut = (0, _KeyboardShortcut.createKeyboardShortcut)(function () {
    return handleToggleModal(true);
  }, (0, _KeyTesters.keyCombination)(_KeyTesters.anyOf.apply(void 0, (0, _toConsumableArray2.default)(_KeyCodes.MODIFIER_KEYS)), (0, _KeyTesters.exactly)(getShortcutActionKey())));
  var shortcutHandler = (0, _ProfileKeyboardShortcutHandler.createShortcutHandler)(openModalShortcut);
  (0, _react.useEffect)(function () {
    shortcutHandler.initializeShortcutListener();
    return function cleanup() {
      shortcutHandler.removeShortcutListener();
    };
  });

  if (!isOpen) {
    return null;
  }

  return _react.default.createElement(_UIModal.default, {
    width: MODAL_WIDTH,
    onEsc: function onEsc() {
      return handleToggleModal(false);
    }
  }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: function onClick() {
      return handleToggleModal(false);
    }
  }), _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "profileTimeline.actionsSearchModal.modalTitle"
  }))), renderAcitonTypeahead(), _react.default.createElement(_HR.default, {
    className: "m-y-3"
  }), renderControlsReminder());
}

ProfileActionSearch.propTypes = {
  handleOpenSequencesModal: _propTypes.default.func.isRequired,
  showSequences: _propTypes.default.bool
};
module.exports = exports.default;